import React, { Component } from 'react'
import Features from './Features'
import Teachers from './Teachers'
import Hero from './Hero'
import ExploreOnlineClasses from './ExploreOnlineClasses'

export default class Home extends Component {
    render() {
        return (
            <div className="home-content">
                <Hero />
                <ExploreOnlineClasses />
                <Features />
                <Teachers />
            </div>
        )
    }
}
